import React from "react";
import { TableBody } from "../../types";
import { TableRowContainer, TableCell } from "./styled-components";

interface Props {
  content: TableBody;
}

export const validateValue = (
  valueToValidate: string | null | undefined
): boolean => valueToValidate !== undefined && valueToValidate !== "";

const defaultContent: TableBody = {
  firstCellText: "",
  secondCellText: "",
  thirdCellText: "",
  fourthCellText: "",
  firstCellTextColor: "",
  secondCellTextColor: "",
  thirdCellTextColor: "",
  fourthCellTextColor: ""
};

const TableRow: React.FC<Props> = ({ content = defaultContent }) => {
  const textArrays: string[] = [];
  const textColorArrays: string[] = [];
  const moreThanOneColor = validateValue(content.secondCellTextColor);

  textArrays.push(content.firstCellText);
  textArrays.push(content.secondCellText);
  textColorArrays.push(content.firstCellTextColor);

  if (moreThanOneColor) {
    textColorArrays.push(content.secondCellTextColor as string);
  }

  if (validateValue(content.thirdCellText)) {
    textArrays.push(content.thirdCellText as string);

    if (moreThanOneColor && validateValue(content.thirdCellTextColor)) {
      textColorArrays.push(content.thirdCellTextColor as string);
    }

    if (validateValue(content.fourthCellText)) {
      textArrays.push(content.fourthCellText as string);

      if (moreThanOneColor && validateValue(content.fourthCellTextColor)) {
        textColorArrays.push(content.fourthCellTextColor as string);
      }
    }
  }

  return (
    <TableRowContainer length={textArrays.length} data-qa-label="table-row">
      {textArrays.map((cellText, index) => (
        <TableCell
          length={textArrays.length}
          index={index}
          color={
            textColorArrays[index] === undefined
              ? textColorArrays[0]
              : textColorArrays[index]
          }
          key={cellText}
        >
          {cellText}
        </TableCell>
      ))}
    </TableRowContainer>
  );
};

export default TableRow;
